import React from "react";
import "./radio.css";
import { IReasonRequest } from "dto";

interface IRadioProps {
  reason: IReasonRequest;
  selectedOption: string | null;
  handleRadioChange: (event: string) => void;
}

const Radio: React.FC<IRadioProps> = (RadioProps: IRadioProps) => {
  const { reason, selectedOption, handleRadioChange } = RadioProps;
  return (
    <div className="wrapper-radio">
      <label className="custom-radio d-flex align-items-center mb-3">
        <input
          type="radio"
          value={reason.value}
          checked={selectedOption === `${reason.label}`}
          onChange={() => handleRadioChange(reason.label)}
        />
        <div className="wrapper-radio-mark d-flex align-items-center">
          <span className="custom-radio-mark"></span>
        </div>
        <h4>{reason.label}</h4>
      </label>
    </div>
  );
};

export default Radio;
